function membershipServiceMock() {
  function exportMembershipCard<IMembership>(id: string, showCredentials: boolean) {
    return `/api/membership/ExportMembershipCard?ssouuid=${id}&memberId=${id}&showCredentials=${showCredentials}`;
  }

  function exportMembershipCertificate<IAccount>(
    id: string,
    showCredentials: boolean,
    isLetterSize: boolean
  ) {
    return `/api/membership/ExportMembershipCertificate?ssouuid=${id}&memberId=${id}&showCredentials=${showCredentials}&isLetterSize=${isLetterSize}`;
  }

  return {
    exportMembershipCard,
    exportMembershipCertificate,
  };
}

export default membershipServiceMock;
